import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { Textarea } from "@/components/elements/Textarea";
import { OnboardingSupportFields } from "@/features/job/components/job-form/OnboardingSupportFields";

type TJobFeatureProps = {
  isDraft?: boolean;
  onboardingSupportRef: React.MutableRefObject<(HTMLDivElement | null)>;
};

export const JobFeature: FC<TJobFeatureProps> = ({ ...rest }) => {
  const methods = useFormContext<TJobForm>();
  const { control } = methods;

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="特性" /> } showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormField control={control} name="memo">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="jobMemo">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="foreignEmployees">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <OnboardingSupportFields {...rest}/>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
